const annualIncome = ["$0-$20,000", "$20,000-$50,000", "$50,000-$100,000", "$100,000-$200,000", "more than $200,000"];
export default annualIncome;